"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { fetchCertifiedMedicines } from "@/entities/certified-medicine/api/certified-medicines";
export function useMedicineCertificates(medicineId, enabled) {
  const $ = _c(8);
  let t0;
  if ($[0] !== medicineId) {
    t0 = ["dashboard", "medicines", "certificates", medicineId];
    $[0] = medicineId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = enabled && medicineId != null;
  let t2;
  if ($[2] !== medicineId) {
    t2 = () => fetchCertifiedMedicines({
      medicineId,
      limit: 50,
      sortBy: "certificate_issued_at",
      sortOrder: "desc"
    });
    $[2] = medicineId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      enabled: t1,
      queryFn: t2,
      staleTime: 60000
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
}